import { call, put, takeLatest } from "redux-saga/effects";
import { PayloadAction } from "@reduxjs/toolkit";
import {
  login,
  register,
  loginStart,
  registerStart,
  loginSuccess,
  registerSuccess,
  loginFailure,
  registerFailure,
  logout,
  forgotPassword,
  forgotPasswordStart,
  forgotPasswordSuccess,
  forgotPasswordFailure,
  setPassword,
  setPasswordStart,
  setPasswordSuccess,
  setPasswordFailure,
  
} from "../slices/authSlice";
import { makeRequest } from "../../utils/api";
import {
  LoginCredentials,
  RegisterCredentials,
  ForgotPasswordPayload,
  SetPasswordPayload,
} from "../../types/saga";
import { extractErrorMessage } from "../../utils/helpers";
import { toast } from "react-toastify";

function* loginSaga(
  action: PayloadAction<LoginCredentials>
): Generator<any, void, any> {
  try {
    yield put(loginStart());

    const response: any = yield call(
      makeRequest,
      "post",
      "/users/login",
      action.payload
    );

    // Store tokens in sessionStorage

    if (response?.access_token) {
      sessionStorage.setItem("access", response.access_token);
    }

    yield put(
      loginSuccess({
        user: response.user,
      })
    );
  } catch (error: any) {
    yield put(loginFailure(extractErrorMessage(error)));
  }
}

function* registerSaga(
  action: PayloadAction<RegisterCredentials>
): Generator<any, void, any> {
  try {
    yield put(registerStart());
    const response: any = yield call(
      makeRequest,
      "post",
      "/users/register",
      action.payload
    );
    yield put(
      registerSuccess({
        user: response.user,
      })
    );
    toast.success(response.message ?? "Signup created successfully!");
  } catch (error: any) {
    yield put(registerFailure(extractErrorMessage(error)));
  }
}

function* logoutSaga() {
  yield sessionStorage.removeItem("access");
  yield sessionStorage.removeItem("refresh");
}

function* forgotPasswordSaga(
  action: PayloadAction<ForgotPasswordPayload>
): Generator<any, void, any> {
  try {
    yield put(forgotPasswordStart());
    yield call(makeRequest, "post", "/users/forgot-password", action.payload);
    yield put(forgotPasswordSuccess());
  } catch (error: any) {
    yield put(forgotPasswordFailure(extractErrorMessage(error)));
  }
}

function* setPasswordSaga(
  action: PayloadAction<SetPasswordPayload>
): Generator<any, void, any> {
  try {
    yield put(setPasswordStart());
    const { userId, token, password } = action.payload;
    yield call(makeRequest, "post", `/users/set-password/${userId}/${token}`, {
      password,
    });
    yield put(setPasswordSuccess());
    toast.success("Password set successfully!");
  } catch (error: any) {
    yield put(setPasswordFailure(extractErrorMessage(error)));
  }
}

export default function* authSaga(): Generator<any, void, any> {
  yield takeLatest(login.type, loginSaga);
  yield takeLatest(register.type, registerSaga);
  yield takeLatest(logout.type, logoutSaga);
  yield takeLatest(forgotPassword.type, forgotPasswordSaga);
  yield takeLatest(setPassword.type, setPasswordSaga);
}
